import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


import { LoginComponent } from './components/login/login.component';

import { MyChartComponent } from './components/my-chart/my-chart.component';

import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { UserConfigurationComponent } from './components/user-configuration/user-configuration.component';
import { ErrorComponent } from './error.component';
import { ENavigationRoute } from './model/enum/navigation-route';
import { ConfigurationGuard } from './tools/configuration.guard';
import { LoginGuard } from './tools/login-guard';
import { RedirectComponent } from './components/redirect/redirect.component';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: ENavigationRoute.Chart },
    { path: ENavigationRoute.Chart, component: MyChartComponent, canActivate: [LoginGuard] },
   
    { path: ENavigationRoute.Config, component: UserConfigurationComponent, canActivate: [LoginGuard] },

    { path: ENavigationRoute.Login, component: LoginComponent },
    { path: ENavigationRoute.ResetPassword, component: ResetPasswordComponent },
    { path: ENavigationRoute.Error, component: ErrorComponent },
    { path: 'redirect', component: RedirectComponent },
    { path: '**', component: ErrorComponent }
];
@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
